export default __webpack_public_path__ + "static/media/SG-White-0003.87383a94.png";